import { createFileRoute } from "@tanstack/react-router";

import { CoachWorkflowSettingsPage } from "src/pages/CoachWorkflowSettingsPage";

export const Route = createFileRoute(
  "/_auth/_coach/workflows/$workflowId/settings",
)({
  component: RouteComponent,
});

function RouteComponent() {
  return <CoachWorkflowSettingsPage />;
}
